import { Card, Col, Flex, Row } from 'antd'

import { HivAnamnesisCaseResponse } from 'src/api/requests'
import { Text } from 'src/components'
import { formatUtcDateTime } from 'src/libs'
import { useLocales } from 'src/locales'

import { HivAnamnesisStatusTag } from './HivAnamnesisStatusTag'

type Props = {
  hivAnamnesisCase?: HivAnamnesisCaseResponse
}

/** Status of the record: a new form shows only the draft / completed explanation. */
export const HivAnamnesisStatusCard = ({ hivAnamnesisCase }: Props) => {
  const { t } = useLocales()

  const items = [
    {
      label: t('hiv_anamnesis.status_label'),
      value: <HivAnamnesisStatusTag status={hivAnamnesisCase?.status} />
    },
    {
      label: t('hiv_anamnesis.created_at'),
      value: formatUtcDateTime(hivAnamnesisCase?.createdAt)
    },
    {
      label: t('hiv_anamnesis.updated_at'),
      value: formatUtcDateTime(hivAnamnesisCase?.updatedAt)
    },
    {
      label: t('hiv_anamnesis.completed_at'),
      value: formatUtcDateTime(hivAnamnesisCase?.completedAt)
    }
  ]

  return (
    <Card title={t('hiv_anamnesis.full_title')}>
      <Flex vertical gap={16}>
        <Text>{t('hiv_anamnesis.draft_hint')}</Text>

        {hivAnamnesisCase?.id && (
          <Row gutter={[24, 24]}>
            {items.map((item) => (
              <Col key={item.label} xs={24} lg={6}>
                <Flex vertical gap={4}>
                  <Text>{item.label}</Text>
                  <Text weight={400}>{item.value}</Text>
                </Flex>
              </Col>
            ))}
          </Row>
        )}
      </Flex>
    </Card>
  )
}
